import React, { useCallback } from 'react';
// import { PostCover, PostAuthor, PostDetail } from '../post-feeds/post-feeds.component';
import './content-card.style.css';
import axios from 'axios'
import UserContext from '../../utils/userContext'
import { CommentPost } from '../comment-post/comment-post.component';
import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';
import 'highlight.js/styles/github.css';
import { Viewer } from '@toast-ui/react-editor';
import codeSyntaxHighlight from '@toast-ui/editor-plugin-code-syntax-highlight';
import { FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon } from "react-share";
import { Helmet } from "react-helmet";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ProfileSideMenu } from '../profile-card/profile-card.component';
import { FeedHighlightSideMenu, FeedHighlightSideLast } from '../feed-highlight/feed-highlight.component';
import BlogBookmark from '../blog-bookmark/blog-bookmark.component';
import { ModalMenu } from '../modal/modal.component'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
    Link, Redirect
} from 'react-router-dom'
import 'dayjs/locale/th'

library.add(fas, far);


var dayjs = require('dayjs')


const ReferenceViewer = (props) => {

    return (
        <div>
            <div><b>Titile:</b> {props.refTitle}</div>
            <div><b>Url:</b> <a href={props.refUrl} className="ref-url">{props.refUrl}</a></div>
        </div>
    )
}







const ReactionMiniHeart = (props) => {
    let onMHClick = props.voteClickAble === true ? props.onMiniHeartClick : ""
    return (
        <>
            <div className="post-vote-segment" onClick={onMHClick}>
                {props.reaction === 0 ? <FontAwesomeIcon style={{ fontSize: "20px", color: "grey" }} icon={['far', 'heart']} /> : <FontAwesomeIcon style={{ fontSize: "20px", color: "salmon" }} icon={['fas', 'heart']} />}
            </div>
        </>
    )
}

const ReactionBookmark = (props) => {

    return (
        <>
            <div className="post-vote-segment" onClick={props.onBookmarkClick}>
                {props.reaction === 0 ? <FontAwesomeIcon style={{ fontSize: "20px", color: "grey" }} icon={['far', 'bookmark']} /> : <FontAwesomeIcon style={{ fontSize: "20px", color: "FFC000" }} icon={['fas', 'bookmark']} />}
            </div>
        </>
    )
}



const ContentData = (props) => {
    var viewerRef = React.createRef();

    return (
        <div>
            <PostCover coverImage={props.post.coverImage} />
            <div className="post-author-edit-wrap">
                <PostAuthor authorImage={props.post.authorImage} authorName={props.post.authorName} date={props.post.date} nicename={props.post.userNicename} />
                {props.owner ? <Link to={`/edit/${props.post.path}`}><div className="post-edit-button">แก้ไข</div></Link> : ""}
            </div>
            <PostDetail title={props.post.title} miniheartCount={props.post.miniheartCount} commentCount={props.post.commentCount} tags={props.post.tags} />
            <div className="post-detail">
                <div className="post-content">
                    <Viewer
                        previewStyle="vertical"
                        initialValue={props.post.content}
                        plugins={[codeSyntaxHighlight]}
                        ref={viewerRef}
                    />
                    <h3>Reference</h3>
                    {
                        props.post.references.map((eachRef, i) => <ReferenceViewer key={i} refTitle={eachRef.title} refUrl={eachRef.url} />)
                    }
                </div>
            </div>
        </div>
    )

}






class ContentCard extends React.Component {
    viewerRef = React.createRef();
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            data: {
                comments: []
            },
            voteClickAble: true,
            firstQuery: false,
            axiosContentCalled: true,
            showShare: false,
            highlightPost: [],
            notFound: false,
            copyStatus: false
        }
        this.showShare = this.showShare.bind(this)
        this.closeShare = this.closeShare.bind(this)
        this.onCopyLink = this.onCopyLink.bind(this)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        this.onLoadData();

    }

    componentDidUpdate(prevProps) {

        if (this.props.location !== prevProps.location) {

            this.onLoadData(true);
        }
    }

    onLoadData(pathChange = false) {

        var self = this;
        if (this.state.axiosContentCalled || pathChange) {
            this.setState({ axiosContentCalled: false, firstQuery: false })

            axios({
                method: 'get',
                url: `https://www.borntodev.com/wp-json/devblog/v1/posts/user/${this.props.match.params.authorName}/${this.props.match.params.contentId}`,
                headers: {
                    'Content-Type': 'multipart/form-data',

                }
            }).then(function (response) {
                // self.setState({ data: response.data })
                self.setState({ data: response.data, firstQuery: true, copyStatus: false })
                window.scrollTo(0, 0)
            })
                .catch(function (response) {
                    self.setState({ notFound: true })
                    // self.onLoadData()
                });


        }
    }

    onMiniHeartClick() {

        var self = this
        self.setState({ voteClickAble: false })
        axios({
            method: 'post',
            url: `https://www.borntodev.com/wp-json/devblog/v1/posts/${self.state.data.contentId}/miniheart`,
            data: { "currentStatus": self.state.data.miniheartSent },
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
            .then(function (response) {
                if (response.data.success) {
                    self.setState({ data: response.data.postData, voteClickAble: true })
                }

            })
            .catch(function (response) {
            });
    }

    onBookmarkClick() {
        var self = this
        let currentBookmark = self.state.data.readinglistSaved;
        let sentMethod
        if (currentBookmark == 0) {
            sentMethod = "post";
        } else {
            sentMethod = "delete";
        }
        axios({
            method: sentMethod,
            url: `https://www.borntodev.com/wp-json/devblog/v1/list/${self.state.data.contentId}`,
            headers: {
                'Content-Type': 'multipart/form-data',

            }
        })
            .then(function (response) {
                if (response.data.success) {
                    self.setState({ data: response.data.postData })
                }
            })
            .catch(function (response) {
            });

    }

    getComment() {
        var self = this;
        axios({
            method: 'get',
            url: `https://www.borntodev.com/wp-json/devblog/v1/posts/${this.props.contentId}/comments`,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
            .then(function (response) {
                self.setState({ comments: response.data })
            })
            .catch(function (response) {
            });
        this.setState({ comments: self.state.comments })
    }


    showShare() {
        this.setState({ showShare: true })

    }

    closeShare() {
        this.setState({ showShare: false })
    }

    onCopyLink() {
        this.setState({ copyStatus: true })
    }



    render() {
        let currentPath = "https://www.borntodev.com/c" + this.props.location.pathname;

        const owner = this.context.userData.id.toString() === this.state.data.authorId;


        return (
            <div className="content-wrap">
                {this.state.notFound ? <Redirect to="/404" /> : ""}
                <div className="content-flex-wrap inner-bg-color pt-15">
                    <HelmetMetaData currentPath={currentPath} image={this.state.data.coverImage} description={this.state.data.contentText} title={this.state.data.title} />

                    <div className="reaction-bar-footer-wrap">
                        {this.state.firstQuery ?
                            <div className="reaction-bar-footer">
                                <div className="rbf-each">
                                    <div>
                                        {this.state.data.miniheartCount}
                                    </div>
                                    <div className="ml-10px pointer">
                                        <ReactionMiniHeart reaction={this.state.data.miniheartSent} voteClickAble={this.state.voteClickAble} onMiniHeartClick={this.onMiniHeartClick.bind(this)} />
                                    </div>
                                </div>
                                <div className="rbf-each">
                                    <div>
                                        {this.state.data.readinglistCount}
                                    </div>
                                    <div className="ml-10px pointer">
                                        <ReactionBookmark reaction={this.state.data.readinglistSaved} onBookmarkClick={this.onBookmarkClick.bind(this)} />
                                    </div>
                                </div>

                                <div>
                                    {this.state.showShare ? <ModalMenu closeModal={this.closeShare} type={'modal-share-footer'} modalComponent={<SocialMediaButtons onCopy={this.onCopyLink} currentPath={currentPath} copyStatus={this.state.copyStatus} />} /> : <></>}
                                    <FontAwesomeIcon style={{ fontSize: "20px", color: "grey", cursor: "pointer" }} icon={['fas', 'ellipsis-h']} onClick={this.showShare} />
                                </div>
                            </div> : ""}
                    </div>

                    <div className="content-reaction-bar">
                        {this.state.firstQuery ?
                            <>
                                <div className="icon-reaction">
                                    <ReactionMiniHeart reaction={this.state.data.miniheartSent} voteClickAble={this.state.voteClickAble} onMiniHeartClick={this.onMiniHeartClick.bind(this)} />
                                </div>
                                <div className="reaction-amount">
                                    {this.state.data.miniheartCount}
                                </div>
                                <div className="icon-reaction">
                                    <ReactionBookmark reaction={this.state.data.readinglistSaved} onBookmarkClick={this.onBookmarkClick.bind(this)} />
                                </div>
                                <div className="reaction-amount">
                                    {this.state.data.readinglistCount}
                                </div>
                                <div className="icon-reaction">
                                    {this.state.showShare ? <ModalMenu closeModal={this.closeShare} type={'modal-share'} modalComponent={<SocialMediaButtons onCopy={this.onCopyLink} currentPath={currentPath} copyStatus={this.state.copyStatus} />} /> : <></>}

                                    <FontAwesomeIcon style={{ fontSize: "20px", color: "grey", marginTop: "20" }} icon={['fas', 'ellipsis-h']} onClick={this.showShare} />
                                </div>
                            </> : ""}
                    </div>


                    <div className="content-space-wrap">

                        <div className="content-card">
                            {
                                this.state.firstQuery === true ?
                                    <ContentData post={this.state.data} contentFirstQuery={this.state.firstQuery} owner={owner} voteClickAble={this.state.voteClickAble} onMiniHeartClick={this.onMiniHeartClick.bind(this)} /> :
                                    <SkeletonPage skeletonHeight={"150vh"} skeletonWidth={"100%"} coverNeed={true} />
                            }
                        </div>

                        {this.state.firstQuery ?
                            <>
                                <CommentPost contentName={this.props.match.params.contentId} firstQuery={this.state.firstQuery} contentId={this.state.data.contentId} />

                            </> : <></>}


                    </div>
                    <div className="content-suggest-bar">
                        <ProfileSideMenu authorImage={this.state.data.authorImage} authorName={this.state.data.authorName} nicename={this.state.data.userNicename} />
                        <FeedHighlightSideMenu posts={this.state.highlightPost} />
                        <BlogBookmark />
                    </div>
                </div>
                <div className="content-flex-wrap inner-bg-color">
                    <div class="content-last-suggest">
                        <FeedHighlightSideLast />
                    </div>
                </div>
            </div>
        )
    }
}

const SocialMediaButtons = (props) => {
    return (
        <div className="more-reaction-modal">
            <FacebookShareButton
                url={props.currentPath}>

                <FacebookIcon size={36} />
            </FacebookShareButton>

            <TwitterShareButton
                url={props.currentPath}>

                <TwitterIcon size={36} />
            </TwitterShareButton>
            <CopyToClipboard onCopy={props.onCopy} text={props.currentPath}>
                <div className={`share-button ${props.copyStatus ? 'sb-link-pressed' : 'sb-link'}`}>
                    <FontAwesomeIcon icon={['fas', 'link']} />
                </div>
            </CopyToClipboard>
        </div>
    );
}

const HelmetMetaData = (props) => {

    // console.log(props.title)

    let currentUrl = props.currentPath
    let quote = props.quote !== "" && props.quote !== undefined ? props.quote : "แชร์ทักษะ ตั้งคำถาม อัพสกิลสายดิจิทัลไปพร้อมกัน | borntoDev";
    let title = props.title !== "" && props.title !== undefined ? props.title : "แชร์ทักษะ ตั้งคำถาม อัพสกิลสายดิจิทัลไปพร้อมกัน";
    let image = props.image !== "" && props.image !== undefined ? props.image : "https://www.borntodev.com/wp-content/uploads/2020/04/borntodev-80x80-1.png";
    let description = props.description !== "" && props.description !== undefined ? props.description.substring(0, 200) : "#borntoDev - 🦖 สร้างการเรียนรู้ที่ดีสำหรับสายไอทีในทุกวัน";
    // let hashtag = props.hashtag !== "" || undefined ? props.hashtag : "";
    return (
        <Helmet>
            <title>{title+" | borntoDev Creator"}</title>
            <link rel="icon" href="https://www.borntodev.com/wp-content/uploads/2020/04/borntodev-80x80-1.png" />
            <meta charset="utf-8" />
            <meta http-equiv="X-UA-Compatible" content="IE=edge" />
            <meta name="csrf_token" content={title+" | borntoDev Creator"} />
            <meta property="type" content="website" />
            <meta property="url" content={currentUrl} />
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
            <meta name="msapplication-TileColor" content="#ffc000" />
            <meta name="msapplication-TileImage" content="https://www.borntodev.com/wp-content/uploads/2020/04/borntodev-80x80-1.png" />
            <meta name="theme-color" content="#ffc000" />
            <meta name="_token" content="" />
            <meta name="robots" content="noodp" />
            <meta property="title" content={title+" | borntoDev Creator"} />
            <meta property="quote" content={quote+" | borntoDev Creator"} />
            <meta name="description" content={description} />
            <meta property="image" content={image} />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title+" | borntoDev Creator"} />
            <meta property="og:quote" content={quote+" | borntoDev Creator"} />
            <meta property="og:image" content={image} />
            <meta content="image/*" property="og:image:type" />
            <meta property="og:url" content={currentUrl} />
            <meta property="og:site_name" content="borntoDev" />
            <meta property="og:description" content={description} />
            <meta property="fb:app_id" content="2813844808900447" />
        </Helmet>
    );
}

const SkeletonPage = (props) => {
    return (
        <div className="skeleton-wrap" style={{ width: props.skeletonWidth, backgroundColor: "white", borderRadius: "5px" }}>

            {props.coverNeed === true ? <div className="post-cover expand" style={{ backgroundColor: "rgb(231, 231, 231)" }} ></div> : ""}
            <div className="post-author expand" >
                <table>
                    <tbody>
                        <tr>
                            <td className="post-author-image" style={{ backgroundColor: "rgb(231, 231, 231)" }}></td>
                            <td className="post-author-text">
                                <div className="skeleton" style={{ width: "100px", marginTop: "3px" }}></div>
                                <div className="skeleton" style={{ width: "150px", marginTop: "4px" }}></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="post-detail" style={{ height: props.skeletonHeight }}>
                <div className="skeleton" style={{ width: "300px", height: "30px", marginTop: "10px" }}></div>
            </div>

        </div >
    )
}

const PostCover = (props) => (
    props.coverImage !== "" ? <div className="post-cover expand" style={{ backgroundImage: `url(${props.coverImage})` }} ></div> : ""
)

const PostAuthor = (props) => {
    var thaiMonth = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ษ", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."]
    var mydate = props.date;
    if (mydate !== "") {
        mydate = (dayjs(props.date));
        mydate = mydate['$D'] + " " + thaiMonth[mydate['$M']] + " " + (543 + mydate['$y'])
    }

    return (
        <div className="post-author">

            <div>
                <Link to={`/${props.nicename}`}>
                    <img className="post-author-image" src={props.authorImage} />
                </Link>
            </div>

            <div className="post-author-text">
                <Link to={`/${props.nicename}`}>
                    <div className="post-author-name">{props.authorName}</div>
                </Link>
                <div className="post-author-date">{mydate}</div>
            </div>

        </div>
    )
}

const PostDetailHead = (props) => (
    <div>
        <div className="post-title expand">
            {props.title}
        </div>
    </div>
)





const Tag = ({ value }) => {
    return (
        <Link className="a-link" to={`/tag/${value.tagName}`}>
            <span className="post-tag" >#{value.tagName}</span>
        </Link>
    )
};

const TagsList = ({ items }) => (
    <span>
        {
            items.map((item, i) => <Tag key={i} value={item} />)
        }
    </span>
);


const PostDetailReaction = (props) => (
    <div className="post-reaction-segment">
        <span style={{ color: "salmon" }}>❤</span> {props.miniheartCount}
        <span> 💬 {props.commentCount}</span>
    </div>
)

const PostDetail = (props) => {
    return (
        <div className="post-detail">
            <PostDetailHead title={props.title} />
            <div className="post-tag-segment expand">
                <PostDetailReaction miniheartCount={props.miniheartCount} commentCount={props.commentCount} />
                <TagsList items={props.tags} />
            </div>
        </div>
    )
}




export default ContentCard;

export { SkeletonPage, ReferenceViewer, PostCover, PostAuthor, PostDetail };
